import { all } from 'redux-saga/effects';

/**
 * Saga Reducer Hooks
 */
export default function* sagas() {
  yield all([]);
}
